import { RealmType } from '../enums/realm-type.enum';
import { ServerPermission } from '../enums/server-permission.enum';
import { AccessToken } from '../services/api/general/access-token';
import { Serializable, Serialized, SerializeUtil } from '../utils/serialize';
import { Enterprise } from './enterprise';
import { Realm } from './realm';

export class User implements Serializable {
  @Serialized()
  public adminId: string;

  @Serialized({
    list: true,
    serialize: instance => instance.serialize(),
    deserialize: Realm.deserialize
  })
  public realms: Realm[];

  @Serialized()
  public currentRealmId: string;

  /**
   * Initial token to get realms and realm access token
   */
  @Serialized({
    serialize: instance => instance.serialize(),
    deserialize: AccessToken.deserialize,
  })
  public accessToken: AccessToken;

  /**
   * The user's access token for server requests.
   */
   @Serialized({
    serialize: instance => instance.serialize(),
    deserialize: AccessToken.deserialize,
  })
  public realmAccessToken: AccessToken;

  public get currentRealm(): Realm | undefined {
    return this.realms?.find(realm => realm.id === this.currentRealmId);
  }

  public get permissions(): ServerPermission[] {
    return this.currentRealm?.permissions ?? [];
  }

  public get enterprise(): Enterprise | undefined {
    return this.currentRealm?.enterprise;
  }

  public set enterprise(value: Enterprise) {
    this.currentRealm.enterprise = value;
  }

  public get enterpriseId(): string | undefined {
    return this.currentRealm?.type === RealmType.Enterprise ? this.currentRealmId : undefined;
  }

  public serialize(): string {
    return SerializeUtil.deepSerialize(this);
  }

  public static deserialize(serialized: string | object): User {
    const u = new User();
    return SerializeUtil.deepDeserialize(u, serialized);
  }

  public static fromRealms(realms: Realm[], accessToken: AccessToken): User {
    const user = new User();
    user.realms = realms;
    user.accessToken = accessToken;
    return user;
  }

  public hasValidToken(): boolean {
    return !!this.accessToken?.isValid() || !!this.realmAccessToken?.isValid();
  }
}
